'use client';

import { IconBilly, IconBitly, IconHome } from '@/components/ui/icons';
import Link from 'next/link';
import React from 'react';
import { useSession } from 'next-auth/react';
import { Sidebar } from './sidebar';
import { SidebarFooter } from './sidebar-footer';
import { SidebarList } from './sidebar-list';
import { ThemeToggle } from './theme-toggle';
import { UserMenu } from './user-menu';
import UserPreferences from './user-preferences-sheet';

export function Header() {
    const { data: session } = useSession();

    const handleLogoClick = () => {
        console.log('Logo clicked, navigating to /'); // Debug log
        // Force a hard navigation instead of using the router
        window.location.href = '/';
    };

    return (
        <header className="sticky top-0 z-50 flex h-16 w-full shrink-0 items-center justify-between border-b bg-gradient-to-b from-background/10 via-background/50 to-background/80 px-4 backdrop-blur-xl">
            <div className="flex items-center space-x-4">
                <div className="hidden sm:block">
                    <Link
                        href="http://bitly.com"
                        target="_blank"
                        rel="nofollow"
                        prefetch={false}
                    >
                        <IconHome className="ml-4 h-6 w-6" />
                    </Link>
                </div>
                {session?.user && (
                    <>
                        <Sidebar>
                            <React.Suspense
                                fallback={
                                    <div className="flex-1 overflow-auto" />
                                }
                            >
                                {/* @ts-ignore */}
                                <SidebarList userId={session?.user?.id} />
                            </React.Suspense>
                            <SidebarFooter>
                                <ThemeToggle />
                            </SidebarFooter>
                        </Sidebar>
                    </>
                )}
            </div>
            <div className="flex items-center justify-center">
                <button
                    onClick={handleLogoClick}
                    className="focus:outline-none cursor-pointer intentional-nav"
                    aria-label="Go to home page"
                >
                    <IconBilly className="hidden sm:block" />
                    <IconBitly className="block sm:hidden" />
                </button>
            </div>
            <div className="flex items-center justify-end space-x-0">
                {session?.user && (
                    <>
                        <UserMenu user={session.user} />
                        <div className="hidden sm:block">
                            <UserPreferences />
                        </div>
                    </>
                )}
            </div>
        </header>
    );
}
